import SharePage from "./SharePage";
export default SharePage;
